<template>
  <v-app
    id="app"
    :class="{ noto: isNotoFontFamily }">
    <router-view v-if="!isShowMobileNotification" />
    <MobileNotification :show="isShowMobileNotification" />
    <MobileSimpleNotification :show="isShowMobileSimpleNotification" />
  </v-app>
</template>

<script>
import MobileNotification from '@/components/MobileNotification'
import MobileSimpleNotification from '@/components/MobileSimpleNotification'
import { setToken, getToken } from '@/util/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    MobileNotification,
    MobileSimpleNotification
  },
  data () {
    return {
      // mobileNotificationCount: 0
    }
  },
  computed: {
    ...mapGetters('system', {
      isMobile: 'isMobile',
      isShowMobileNotification: 'isShowMobileNotification',
      isShowMobileSimpleNotification: 'isShowMobileSimpleNotification'
    }),
    isNotoFontFamily () {
      return this.$i18n.locale !== 'en-US'
    }
  },
  async created () {
    await this.$store.dispatch('system/setMobileDetect')
    this.shouldResetCookiesExpires()
  },
  mounted () {
    this.getScreenWidth()
    this.getScreenHeight()
    window.addEventListener('resize', this.getScreenWidth)
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getScreenWidth)
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    shouldResetCookiesExpires () {
      // NOTE: 進入 web 重置 token 的有效期限
      const token = getToken()
      if (token) setToken(token)
    },
    // 設置 螢幕高度 vh 使其在手機版網頁也能正確響應
    getScreenHeight () {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      this.$store.commit('system/SET_SCREEN_HEIGHT', vh * 100)
    },
    // 設置 螢幕寬度 vw 使其在手機版網頁也能正確響應
    getScreenWidth () {
      // First we get the viewport width and we multiple it by 1% to get a value for a vw unit
      let vw = window.innerWidth * 0.01
      // Then we set the value in the --vw custom property to the root of the document
      document.documentElement.style.setProperty('--vw', `${vw}px`)
      this.$store.commit('system/SET_SCREEN_WIDTH', vw * 100)
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@100;300;400;500;700;900&family=Noto+Sans+TC:wght@100;300;400;500;700;900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");

html {
  font-size: 16px !important;
}

.application {
  &.noto {
    *:not(i) {
      font-family: "Noto Sans TC", "Noto Sans SC", sans-serif !important;
    }
  }
}

.application--wrap {
  position: absolute;
  height: calc(var(--vh, 1vh) * 100) !important;
  min-height: calc(var(--vh, 1vh) * 100) !important;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue